import { UploadLimits, ValidationErrorCode } from './constants.js';

function makeError(code, message) {
  return { code, message };
}

export function validateUpload(fileList) {
  const files = Array.from(fileList ?? []);

  if (files.length === 0) {
    return {
      ok: false,
      acceptedFiles: [],
      errors: [makeError(ValidationErrorCode.EMPTY_SELECTION, '你还没有选择图片。请先选择 1-40 张图片。')]
    };
  }

  if (files.length > UploadLimits.MAX_FILES) {
    return {
      ok: false,
      acceptedFiles: [],
      errors: [
        makeError(
          ValidationErrorCode.TOO_MANY_FILES,
          `一次最多上传 ${UploadLimits.MAX_FILES} 张图片，你当前选择了 ${files.length} 张。`
        )
      ]
    };
  }

  const errors = [];
  for (const file of files) {
    if (!file.type.startsWith('image/')) {
      errors.push(makeError(ValidationErrorCode.INVALID_TYPE, `“${file.name}” 不是图片格式，请重新选择。`));
      break;
    }
    if (file.size > UploadLimits.MAX_FILE_BYTES) {
      errors.push(
        makeError(
          ValidationErrorCode.FILE_TOO_LARGE,
          `“${file.name}” 超过 2MB，请替换后重试。`
        )
      );
      break;
    }
  }

  if (errors.length > 0) {
    return {
      ok: false,
      acceptedFiles: [],
      errors
    };
  }

  return {
    ok: true,
    acceptedFiles: files,
    errors: []
  };
}
